import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

export default function RiskAlertPanel({ alerts }) {
  const navigate = useNavigate();

  const severityConfig = {
    critical: { color: "var(--color-error)", bg: "var(--color-error)10", icon: "AlertCircle", label: "Crítico" },
    warning: { color: "var(--color-warning)", bg: "var(--color-warning)10", icon: "AlertTriangle", label: "Aviso" },
    info: { color: "var(--color-accent)", bg: "var(--color-accent)10", icon: "Info", label: "Info" },
    success: { color: "var(--color-success)", bg: "var(--color-success)10", icon: "CheckCircle", label: "OK" },
  };

  return (
    <div className="card p-4 lg:p-5 flex flex-col gap-3 min-w-0">
      <div className="flex items-center justify-between">
        <h3 className="font-heading font-semibold text-base text-foreground">Alertas de Riesgo</h3>
        <span className="badge-error text-xs">{alerts?.filter(a => a?.severity === "critical")?.length} críticas</span>
      </div>
      <div className="flex flex-col gap-2 overflow-y-auto" style={{ maxHeight: "320px" }}>
        {alerts?.map((alert) => {
          const cfg = severityConfig?.[alert?.severity];
          return (
            <div
              key={alert?.id}
              className="flex items-start gap-3 p-3 rounded-lg border border-border"
              style={{ background: cfg?.bg }}
            >
              <Icon name={cfg?.icon} size={16} color={cfg?.color} strokeWidth={2} className="flex-shrink-0 mt-0.5" />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-caption font-medium text-foreground leading-snug">{alert?.message}</p>
                <p className="text-xs text-muted-foreground font-caption mt-0.5">{alert?.recommendation}</p>
                <p className="text-xs font-data text-muted-foreground mt-1">{alert?.time}</p>
              </div>
              {alert?.route && (
                <button
                  onClick={() => navigate(alert?.route)}
                  className="flex-shrink-0 text-xs font-caption underline transition-standard hover:opacity-70"
                  style={{ color: cfg?.color }}
                >
                  Ver
                </button>
              )}
            </div>
          );
        })}
      </div>
      <Button variant="outline" size="sm" iconName="Bell" iconPosition="left" onClick={() => {}}>
        Ver todas las alertas
      </Button>
    </div>
  );
}